import { LocationIcon } from 'tt-ui-lib/icons';
import styles from './UserInfoLocationItem.module.scss';

const LOCATION_GRAY = '/images/profile/locationIcon.svg';

const UserInfoLocationItem = ({ location, setIsLocationModal }) => (
  <>
    {location && (
      <div className={styles.itemWrapper} onClick={() => setIsLocationModal(true)}>
        <div className={styles.iconWrapper}>
          <LocationIcon style={{ width: 24, height: 24 }} />
        </div>
        <div className={styles.location}>{location}</div>
      </div>
    )}
  </>
);

export default UserInfoLocationItem;
